import { Chip, ChipProps, styled } from "@mui/material";
import React from "react";

import { MissionStatusLabel } from "src/constants";
import { MissionStatusEnum } from "src/graphql/generated/types";

interface Props extends ChipProps {
  status: MissionStatusEnum;
}

const StyledChip = styled(Chip)<{ status: MissionStatusEnum }>`
  background-color: ${(props) => props.theme.palette.mission.status[props.status]};
  color: ${(props) => props.theme.palette.common.white};
  span {
    font-weight: bold;
  }
`;

export const ChipMission = ({ status, ...chipProps }: Props) => {
  return <StyledChip status={status} label={MissionStatusLabel[status]} {...chipProps} />;
};
